import type { KeycloakUserData } from '@liks/lac-svc-api/esm/models/index';
import { calendarValidityToIsoRange } from '../utils/dateTimeUtils';
import {
  pickUserEnabledField,
  pickUserOptimisticLockFields,
} from '../utils/userUpdateUtils';
import type { LacUpdateUserInput, LacUser } from './lacUserServiceTypes';

export function toLacEnabledUserPayload(
  profile: LacUser,
  enabled: boolean,
): KeycloakUserData {
  // Build an explicit Keycloak payload. Do not spread Lac `User` — its
  // `userId` is the audit creator, not a KeycloakUserData person field.
  return {
    id: profile.id,
    username: profile.name,
    email: profile.email,
    firstName: profile.firstName,
    lastName: profile.lastName,
    enabled,
    ...pickUserOptimisticLockFields({
      id: profile.id,
      version: profile.version,
      stamp: profile.stamp,
      created: profile.created,
    }),
  };
}

export function buildLacUserUpdatePayload(input: LacUpdateUserInput) {
  const validity = calendarValidityToIsoRange(input);

  return {
    ...pickUserOptimisticLockFields(input),
    username: input.username,
    email: input.email,
    firstName: input.firstName,
    lastName: input.lastName,
    ...pickUserEnabledField(input.enabled),
    ...validity,
  };
}
